import React from 'react';

interface FormGroupProps {
    children?: React.ReactNode,
    label: string,
}

const FormGroup = (props: FormGroupProps) => {
    const { children, label } = props;
    return (
        <>
            <div className="form-group">
                <label>{label}</label>
                {children}
            </div>
        </>
    );
};

export default FormGroup;